import { render, staticRenderFns } from "./peopleDetail.vue?vue&type=template&id=52fa404e&scoped=true&"
import script from "./peopleDetail.vue?vue&type=script&lang=js&"
export * from "./peopleDetail.vue?vue&type=script&lang=js&"
import style0 from "./peopleDetail.vue?vue&type=style&index=0&id=52fa404e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fa404e",
  null
  
)

export default component.exports